import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
;
var e, t;
e = window, t = function t(e) {
  "use strict";

  var s = function s(e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          r = !0,
          o = !1,
          i = void 0;
        try {
          for (var a, l = e[Symbol.iterator](); !(r = (a = l.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            !r && l.return && l.return();
          } finally {
            if (o) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    u = window && window.navigator && window.navigator.userAgent,
    t = u ? navigator.userAgent.toLocaleLowerCase() : "";
  function c(e) {
    var t = (e || "0").match(/^(\d*)/);
    return t ? Number(t[1]) : 0;
  }
  function d(e, t) {
    for (var n = "string" == typeof e ? e.split(".") : ["0"], r = "string" == typeof t ? t.split(".") : ["0"], o = Math.max(n.length, r.length), i = 0; i < o; i += 1) {
      var a = c(n[i]),
        l = c(r[i]);
      if (l < a) return 1;
      if (a < l) return -1;
    }
    return 0;
  }
  var n = function (e) {
      for (var t = {}, n = e.replace(/\([^)]+\)/g, "").split(/\s+/), r = "", o = 0; o < n.length; o += 1) {
        var i = n[o],
          a = i.lastIndexOf("/");
        if (a < 0) t[r = i] = "unknown";else {
          var l = i.slice(0, a);
          r && (l = r + " " + l, r = ""), t[l] = i.slice(a - i.length + 1);
        }
      }
      return t;
    }(t),
    f = n.titansx || n.titansnox || "0",
    p = n.ios || "0",
    m = ("wkwebview" in n),
    r = new Promise(function (e, t) {
      if (!u) return t(new Error("can not use isWebpSupported without userAgent"));
      var n = localStorage.getItem("KNB:media"),
        r = null !== n ? n.match(/(.*)\|(.*)/) : [],
        o = s(r, 3),
        i = o[1],
        a = o[2];
      if (i !== f) {
        if (m) -1 < d(f, "11.12.5.10") && -1 < d(p, "11.0") ? (e(1), localStorage.setItem("KNB:media", f + "|1")) : (e(0), localStorage.setItem("KNB:media", f + "|0"));else {
          var l = document.createElement("img");
          l.src = "https://img.meituan.net/scarlett/aaaf049e1f1c0e455850ca51aab7048568.png.webp", l.style.cssText = "position:absolute; top:0; left:0; visibility: hidden;", l.onload = function () {
            e(2), localStorage.setItem("KNB:media", f + "|2"), l.remove();
          }, l.onerror = function () {
            e(0), localStorage.setItem("KNB:media", f + "|0"), l.remove();
          }, document.body.appendChild(l);
        }
      } else e(Number(a));
    });
  function o(e) {
    return 0 < d("11.7", f) ? (console.warn("knb-media not supported"), e) : /^https?/.test(e) ? "knb-media://server?url=" + encodeURIComponent(e) : "knb-media://client?url=" + encodeURIComponent(e);
  }
  var i = o;
  e.getWebpMedia = i, e.getKNBMedia = o, e.isWebpSupported = r, Object.defineProperty(e, "__esModule", {
    value: !0
  });
}, "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(e.KNBMedia = {});